export default __webpack_public_path__ + "static/media/Fred Obiero.b16a76c5.jpeg";